var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreBatchNum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    width: 26,
    height: 26,
    style: {
      borderColor: "rgba(0,0,0,0)",
      borderWidth: "bpx",
      borderStyle: "undefined"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M704 320H320a32 32 0 1 1 0-64h384a32 32 0 0 1 0 64z m0 448H320a32 32 0 0 1 0-64h384a32 32 0 0 1 0 64z m64-128H256a32 32 0 0 1-32-32v-192a32 32 0 0 1 32-32h512a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32zM288 576h448v-128H288v128z",
    fill: "rgba(51,51,51,1)",
    "p-id": 5178,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreBatchNum);
export default __webpack_public_path__ + "static/media/moreBatchNum.ba5582ed.svg";
export { ForwardRef as ReactComponent };